var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.058 35.655a12.87 12.87 0 003.632-9.015c0-3.614-1.52-6.904-3.97-9.3-1.056 8.528-8.66 15.107-17.867 15.066h-4.436C14.656 36.914 19.43 40 24.92 40L40 39.96l-4.942-4.305z",
    fill: "#F5772F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.36 0C8.617-.04 1.52 6.782 1.478 15.188c0 3.98 1.563 7.634 4.182 10.355L0 30.416l17.276.04c8.744 0 15.84-6.781 15.882-15.187C33.2 6.863 26.104 0 17.36 0zm5.914 13.36l-4.393 4.955-3.76-2.152-3.843 4.75-2.45-1.096 5.618-6.985 3.844 2.193 2.618-2.924-2.154-1.137 6.083-2.355.76 6.01-2.323-1.258z",
    fill: "#F5772F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentIco);
export default __webpack_public_path__ + "static/media/commentIco.1f54d386421651b6af32edcb647c1e5b.svg";
export { ForwardRef as ReactComponent };